import React from 'react';
import { hydrateRoot } from 'react-dom/client'; // Utiliser hydrateRoot au lieu de createRoot
import App from './App';

// Hydrater l'application React sur l'élément "react-root"
hydrateRoot(document.getElementById('react-root'), <App />);
